module.exports = __webpack_public_path__ + "static/4x_hr_onboarding_2-358471a387513bb72943fc0743d72f0d.png";